import _slicedToArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import styled from "styled-components";
import Stack from "../Stack";
import Text from "../Text";
import useMediaQuery from "../hooks/useMediaQuery";
var StyledPricingTable = styled.div.withConfig({
  displayName: "PricingTable__StyledPricingTable",
  componentId: "sc-1aibxyh-0"
})([""]);

var PricingTable = function PricingTable(_ref) {
  var children = _ref.children,
      _ref$defaultActiveEle = _ref.defaultActiveElement,
      defaultActiveElement = _ref$defaultActiveEle === void 0 ? 0 : _ref$defaultActiveEle;

  var _useMediaQuery = useMediaQuery(),
      isDesktop = _useMediaQuery.isDesktop;

  var _useState = useState(defaultActiveElement),
      _useState2 = _slicedToArray(_useState, 2),
      activeElement = _useState2[0],
      setActiveElement = _useState2[1];

  var handleOnClick = function handleOnClick(i) {
    return function () {
      if (!isDesktop) {
        setActiveElement(i);
      }
    };
  };

  var resolveBasis = function resolveBasis(item) {
    if (item.length) {
      return "".concat(Math.floor(100 / item.length), "%");
    }

    return "100%";
  };

  return React.createElement(StyledPricingTable, null, React.createElement(Stack, {
    flex: true,
    grow: true,
    spaceAfter: "medium",
    spacing: "condensed",
    align: "stretch",
    desktop: {
      spacing: "natural",
      spaceAfter: "none"
    }
  }, isDesktop ? children : React.Children.map(children, function (child, i) {
    return React.cloneElement(child, {
      active: activeElement === i,
      compact: true,
      basis: resolveBasis(child),
      onClick: handleOnClick(i)
    });
  })), !isDesktop && children && React.createElement(Stack, {
    spacing: "condensed"
  }, React.Children.map(children, function (child, i) {
    if (i === activeElement) {
      return React.createElement(React.Fragment, null, child.props.mobileDescription && React.createElement(Text, {
        weight: "bold",
        size: "normal"
      }, child.props.mobileDescription), child.props.children && React.cloneElement(child.props.children), child.props.action && React.cloneElement(child.props.action));
    }

    return null;
  })));
};

export default PricingTable;
export { default as PricingTableItem } from "./PricingTableItem";